<template>
  <div class="report-button" @click.stop="showPresentationReport()">
    <aha-icon
      name="multiple-choice-w"
      width="18"
      height="18"
      viewBox="0 0 30 30"
      class="mr-0.5"
    />
    <strong>Report</strong>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Utils from '@/util'
import constants from '@/constant'
import socketHelper from '@/helpers/socket/socket-helper'

export default {
  props: {
    presentation: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    ...mapActions('presentationReport', ['selectPresentationAction', 'generateReportAction', 'subscribeReportAction', 'openReportPanelAction']),
    showPresentationReport() {
      this.selectPresentationAction({
        presentation: this.presentation,
      })
      if (this.presentation && this.presentation.uniqueAccessCode) {
        socketHelper.joinRoomPresentation(this.presentation.uniqueAccessCode)
        this.subscribeReportAction(this.presentation)
      }
      this.openReportPanelAction()
      Utils.gaTrackEvent(constants.gaCategories.PRESENTATION_LIST, 'Presentation > Click view report', this.presentation.id)
    },
  },
}
</script>

<style lang="scss" scoped>
  .report-button {
    @apply items-center px-1.5 py-0.5 rounded-md text-xs;
    @apply bg-purple-10 text-purple-50 hover:bg-purple-50 hover:text-base-0 transition-colors;
  }
</style>
